import { React, useEffect, useState, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import styled from 'styled-components';
import { useLanguage } from '../../../Context/LanguageContext';
import { formatPhoneNumber } from '../../../Utils/phoneUtils';

import FetchModule from '../Network/FetchModule';

import DefaultProfile from '../../../image/DefaultProfile.png';
import { ReactComponent as NotificationsSvgIcon } from '../../../image/Notifications.svg';

import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

function NoticeBox() {
  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { t, languageMode } = useLanguage();

  const [nowPage, setNowPage] = useState('Holding');
  const [onView, setOnView] = useState(false);
  const [isProfileError, setIsProfileError] = useState(false);

  const [isNoticeHover, setIsNoticeHover] = useState(false);
  const [holdData, setHoldData] = useState(new Array);
  const [expireData, setExpireData] = useState(new Array);
  const [notReceivedData, setNotReceivedData] = useState([]);
  const [birthData, setBirthData] = useState([]);
  const [newMemberData, setNewMemberData] = useState([]);

  const NoticeButtonRef = useRef();
  const NoticeRef = useRef();

  const history = useHistory();

  useEffect(() => {
    if (onView) {
      NoticeRef.current.style.height = `480px`;
      NoticeRef.current.style.border = `1px solid ${theme.primary}`;
    }
    else {
      NoticeRef.current.style.height = `0px`;
      NoticeRef.current.style.border = `0px`;
    }
  }, [onView])

  useEffect(() => {
    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postData('store/notification', 'POST');

        if (responseData.status === 200) {
          setExpireData(responseData.data[0].expires);
          setHoldData(responseData.data[0].hold);
          setNotReceivedData(responseData.data[0].notReceiveds);
          setNewMemberData(responseData.data[0].newMembers);

          let birthMembers = responseData.data[0].birthDayMembers.slice();

          for (let i = 0; i < birthMembers.length; i++) {
            // birthMembers[i].thisYear = moment().format('YYYY');
            birthMembers[i].year = birthMembers[i].birthDay.slice(0, 4);
            birthMembers[i].month = birthMembers[i].birthDay.slice(4, 6);
            birthMembers[i].day = birthMembers[i].birthDay.slice(6, 8);

            // 12월인 경우만 해당 //
            if (moment().format('MM') === '12') {
              if (birthMembers[i].month === '01') birthMembers[i].thisYear = moment().add(1, 'year').format('YYYY');
              else  birthMembers[i].thisYear = moment().format('YYYY');
            }
            else birthMembers[i].thisYear = moment().format('YYYY');

            birthMembers[i].thisBirth = birthMembers[i].thisYear + '.' + birthMembers[i].month + '.' + birthMembers[i].day;
          }

          birthMembers.sort((a, b) => moment(a.thisBirth).diff(moment(b.thisBirth)) || a.name - b.name);

          setBirthData(birthMembers);
        }
      }
    )();
  }, [])

  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  function onClickOutSide(e) {
    if (NoticeRef.current !== e.target && !NoticeRef.current.contains(e.target) && !NoticeButtonRef.current.contains(e.target)) {
      setOnView(false);
    }
  }

  function onClickMember(data) {
    // data.division === 'MemberShip' ? '회원권' : '락커'
    if (data.division === 'Locker') window.open('/locker', '_blank');
    else if (data.division === 'MemberShip') window.open('/member/valid/detail/' + data.memberId, '_blank');
    else window.open('/member/valid/detail/' + data.memberId, '_blank');

    // setOnView(!onView);
    setOnView(false);
  }

  // 미수금에서 회원 클릭시 //
  function onClickMemberInNotReceivedPrice(data) {
    window.open('/member/valid/detail/' + data.memberId, '_blank');

    setOnView(false);
  }

  function onClickImage() {
    if (onView) setOnView(false);
    else setOnView(true);
  }

  // 생일 몇일 남았는지 표시 //
  function decideRemainBirth(data) {
    let remainDays = moment(moment(data.thisBirth)).diff(moment().format('YYYY.MM.DD'), 'days');

    if (remainDays === 0) return 'D-Day';
    else return 'D-' + remainDays;
  }

  // 회원 프로필 정리 //
  function decideUserProfile(profile) {
    if (isProfileError || profile === '') return DefaultProfile;
    else return profile;
  }

  // 업체 등록 날짜 정리 //
  function decideCreatedDate(date) {
    let remainDays = moment(moment().format('YYYY.MM.DD')).diff(moment(date), 'days');

    if (remainDays === 0) return moment(date).format(t('partnerGym.history.dateFormat')) + ' (D-Day)';
    else return moment(date).format(t('partnerGym.history.dateFormat')) + ' (D+' + remainDays + ')';
  }

  return (
    <TopLevelWrapper>
      <NoticeButton ref={NoticeButtonRef} onMouseOver={() => setIsNoticeHover(true)} onMouseLeave={() => setIsNoticeHover(false)} onClick={onClickImage}>
        <StyledNotificationsSvg style={{ color: isNoticeHover ? theme.subBackground : theme.keyText }} />
        {!isNoticeHover && <RedDot />}
      </NoticeButton>
      <NoticeView ref={NoticeRef}>
        <InfoWrapper>
          <Title>{t('noticeBox.title')}</Title>
          <ButtonWrapper>
            <Button isClicked={nowPage === 'Holding'} onClick={() => setNowPage('Holding')}>{t('noticeBox.holdRequest')}</Button>
            <Button isClicked={nowPage === 'Expired'} onClick={() => setNowPage('Expired')}>{t('noticeBox.expiringSoon')}</Button>
            <Button isClicked={nowPage === 'NotReceived'} onClick={() => setNowPage('NotReceived')}>{t('noticeBox.notReceived')}</Button>
            <Button isClicked={nowPage === 'Birth'} onClick={() => setNowPage('Birth')}>{t('noticeBox.birthdayMember')}</Button>
            <Button isClicked={nowPage === 'NewMember'} onClick={() => setNowPage('NewMember')}>{t('noticeBox.newMember')}</Button>
          </ButtonWrapper>
          {
            nowPage === 'Holding' &&
            <InfoBox>
              <ColumnWrapper>
                <Column style={{ width: `74px` }}>{t('noticeBox.name')}</Column>
                <Column style={{ width: `76px` }}>{t('noticeBox.appliedDays')}</Column>
                <Column style={{ width: `81px` }}>{t('noticeBox.remainingDays')}</Column>
                <Column style={{ width: `106px` }}>{t('noticeBox.requestDate')}</Column>
              </ColumnWrapper>
              {
                holdData.map((data, index) => (
                  <Info key={index} onClick={() => onClickMember(data)}>
                    <Tr>
                      <Td style={{ width: `66px`, height: `20px`, overflow: `hidden`, marginRight: `8px` }}>{data.name}</Td>
                      <Td style={{ width: `68px`, marginRight: `8px` }}>{(moment(data.endDate).diff(moment(data.startDate), 'day') + 1) + t('noticeBox.dayUnit')}</Td>
                      {/* <Td style={{ width: `83px`, marginRight: `8px` }}>{data.redundancyDay}일</Td> */}
                      <Td style={{ width: `73px`, marginRight: `8px` }}>{data.redundancyDay}{t('noticeBox.dayUnit')}</Td>
                      {/* <Td style={{ width: `70px` }}>{moment(data.startDate).format('YYYY.MM.DD')}</Td> */}
                      <Td style={{ width: `90px`, marginRight: `16px` }}>{moment(data.startDate).format(t('noticeBox.dateFormatShort')) + ' - ' + moment(data.endDate).format(t('noticeBox.dateFormatShort'))}</Td>
                      {
                        moment(data.startDate).isBefore(moment()) ?
                          <DdayBox>
                            <Text fontFmaily='NotoSansKR-Regular' fontSize={11} color={theme.subBackground} hover='pointer'>{t('noticeBox.holding')}</Text>
                          </DdayBox>
                          :
                          <Text fontFmaily='NotoSansKR-Regular' fontSize={11} color={theme.subText} hover='pointer'>{t('noticeBox.holdScheduled')}</Text>
                      }
                    </Tr>
                  </Info>
                ))
              }
            </InfoBox>
          }
          {
            nowPage === 'Expired' &&
            <InfoBox>
              <ColumnWrapper>
                <Column style={{ width: `74px` }}>{t('noticeBox.name')}</Column>
                <Column style={{ width: `76px` }}>{t('noticeBox.division')}</Column>
                <Column style={{ width: `91px` }}>{t('noticeBox.remainingDays')}</Column>
                <Column style={{ width: `86px` }}>{t('noticeBox.expiryDate')}</Column>
              </ColumnWrapper>
              {
                expireData.map((data, index) => (
                  <Info key={index} onClick={() => onClickMember(data)}>
                    <Tr>
                      <Td style={{ width: `66px`, height: `20px`, marginRight: `8px`, overflow: `hidden` }}>{data.name}</Td>
                      <Td style={{ width: `68px`, marginRight: `8px` }}>{data.division === 'MemberShip' ? t('noticeBox.membership') : t('noticeBox.locker')}</Td>
                      {/* <Td style={{ width: `83px`, marginRight: `8px` }}>{moment(data.endDate).diff(moment(), 'day') === 0 ? 'D-day' : moment(data.endDate).diff(moment(), 'day') + '일'}</Td> */}
                      <Td style={{ width: `83px`, marginRight: `8px` }}>{moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'day') === 0 ? 'D-day' : 'D-' + moment(moment(data.endDate).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'day')}</Td>
                      <Td style={{ width: `70px`, marginRight: `16px` }}>{moment(data.endDate).format(t('partnerGym.history.dateFormat'))}</Td>
                      {
                        data.isSendKakao ?
                          <KakaoBox>
                            <Text fontFmaily='NotoSansKR-Regular' fontSize={11} color={theme.subBackground} hover='pointer'>{t('noticeBox.kakaoSent')}</Text>
                          </KakaoBox>
                          :
                          <Text fontFmaily='NotoSansKR-Regular' fontSize={11} color={theme.bottomText} hover='pointer'>{t('noticeBox.notSent')}</Text>
                      }
                    </Tr>
                  </Info>
                ))
              }
            </InfoBox>
          }
          {
            nowPage === 'NotReceived' &&
            <InfoBox>
              <ColumnWrapper>
                <Column style={{ width: `74px` }}>{t('noticeBox.name')}</Column>
                <Column style={{ width: `136px` }}>{t('noticeBox.purchaseHistory')}</Column>
                <Column style={{ width: `88px` }}>{t('noticeBox.unpaidAmount')}</Column>
                <Column style={{ width: `70px` }}>{t('noticeBox.paymentDate')}</Column>
              </ColumnWrapper>
              {
                notReceivedData.map((data, index) => (
                  <Info key={index} onClick={() => onClickMemberInNotReceivedPrice(data)}>
                    <Tr>
                      <Td style={{ width: `66px`, height: `20px`, marginRight: `8px`, overflow: `hidden` }}>{data.name}</Td>
                      <Td style={{ width: `128px`, height: `20px`, marginRight: `8px`, overflow: `hidden` }}>{data.itemName}</Td>
                      {/* <Td style={{ width: `83px`, marginRight: `8px` }}>{moment(data.endDate).diff(moment(), 'day') === 0 ? 'D-day' : moment(data.endDate).diff(moment(), 'day') + '일'}</Td> */}
                      <Td style={{ width: `80px`, marginRight: `8px` }}>{data.notReceivedPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}</Td>
                      <Td style={{ width: `70px` }}>{moment(data.approvalDate).format(t('partnerGym.history.dateFormat'))}</Td>
                    </Tr>
                  </Info>
                ))
              }
            </InfoBox>
          }
          {
            nowPage === 'Birth' &&
            <InfoBox>
              <ColumnWrapper>
                <Column style={{ width: `68px` }}>{t('noticeBox.name')}</Column>
                <Column style={{ width: `108px` }}>{t('noticeBox.birthDate')}</Column>
                <Column style={{ width: `158px` }}>{t('noticeBox.phone')}</Column>
              </ColumnWrapper>
              {
                birthData.map((data, index) => (
                  <Info key={index} onClick={() => onClickMemberInNotReceivedPrice(data)}>
                    <Tr>
                      <Td style={{ width: `60px`, height: `20px`, marginRight: `8px`, overflow: `hidden` }}>{data.name}</Td>
                      <Td style={{ width: `100px`, height: `20px`, marginRight: `8px`, overflow: `hidden` }}>{data.birthDay.slice(0, 4) + '.' + data.birthDay.slice(4, 6) + '.' + data.birthDay.slice(6, 8)}</Td>
                      <Td style={{ width: `150px`, height: `20px`, marginRight: `8px`, overflow: `hidden`, whiteSpace: `nowrap`, textOverflow: `ellipsis` }}>{formatPhoneNumber(data.phone, data.countryCode, languageMode)}</Td>
                      {/* <Td style={{ width: `45px` }}></Td> */}
                      <DdayBox>
                        <Text fontFmaily='NotoSansKR-Regular' fontSize={11} color={theme.subBackground} hover='pointer'>{decideRemainBirth(data)}</Text>
                      </DdayBox>
                    </Tr>
                  </Info>
                ))
              }
            </InfoBox>
          }
          {
            nowPage === 'NewMember' &&
            <InfoBox>
              <ColumnWrapper>
                <Column style={{ width: `68px`, marginLeft: `68px` }}>{t('noticeBox.name')}</Column>
                <Column style={{ width: `136px` }}>{t('noticeBox.registrationDate')}</Column>
                <Column style={{ width: `108px` }}>{t('noticeBox.phone')}</Column>
              </ColumnWrapper>
              {
                newMemberData.map((data, index) => (
                  <Info key={index} style={{ marginTop: '4px', paddingBottom: '4px' }} onClick={() => onClickMemberInNotReceivedPrice(data)}>
                    <Tr>
                      <Td style={{ width: `60px`, height: `42px`, marginRight: `8px`, overflow: `hidden` }}>
                        <ProfileBox src={decideUserProfile(data.profile)} onError={() => setIsProfileError(true)}/>
                      </Td>
                      <Td style={{ width: `60px`, height: `20px`, marginRight: `8px`, overflow: `hidden` }}>{data.name}</Td>
                      <Td style={{ width: `128px`, height: `20px`, marginRight: `8px`, overflow: `hidden` }}>{decideCreatedDate(data.createdDate)}</Td>
                      <Td style={{ width: `100px`, height: `20px`, marginRight: `8px`, overflow: `hidden`, whiteSpace: `nowrap`, textOverflow: `ellipsis` }}>{formatPhoneNumber(data.phone, data.countryCode, languageMode)}</Td>
                    </Tr>
                  </Info>
                ))
              }
            </InfoBox>
          }
        </InfoWrapper>
      </NoticeView>
    </TopLevelWrapper>
  )
}

export default NoticeBox;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-end;
`;

const NoticeButton = styled.div`
  position: relative;
  display: flex;
  flex-direction: row;

  width: 32px;
  height: 32px;

  border-radius: 32px;

  justify-content: center;
  align-items: center;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${props => props.theme.primary};
    }
  }
`;

const RedDot = styled.div`
  position: absolute;
  top: 5px;
  left: 3.2px;

  width: 9px;
  height: 9px;

  border-radius: 50%;
  background-color: ${props => props.theme.pointRed};
`;

const StyledNotificationsSvg = styled(NotificationsSvgIcon)`
  width: 24px;
  height: auto;

  transition: color 0.3s ease-in-out;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const NoticeView = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 40px;
  margin-right: -20px;

  // width: 399px;
  width: 462px;
  // height: 480px;
  height: 0px;

  overflow: hidden;

  z-index: 100;

  // border: 1px solid #FF8B48;
  border: 0px;
  border-radius: 8px;
  background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  // width: 343px;
  width: 400px;
  height: 424px;
`;

const Title = styled.p`
  font-family: NotoSansKR-Bold;
  font-size: 16px;

  color: ${props => props.theme.text};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: default;
    }
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-top: 24px;

  gap: 16px;
`;

const Button = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding-bottom: 5px;

  border-bottom: ${props => props.isClicked ? `2px solid ${props.theme.primary}` : `2px solid ${props.theme.subBackground}`};

  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.isClicked ? props.theme.text : props.theme.line};

  margin: 0 0 0 0;

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      border-bottom: 2px solid ${props => props.theme.primary};
      color: ${props => props.theme.text};
    }
  }
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  overflow-x: default;
  overflow-y: scroll;

  margin-top: 20px;

  width: 100%;
  height: 332px;

  // border-top: 2px solid #ECECEC;

  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-thumb {
    border: 3px solid transparent;
    // height: 92px;
    background-color: ${props => props.theme.scrollBar};
    border-radius: 200px;
  }

  &::-webkit-scrollbar-track {
    // height: 439px;
    // border: 4px solid transparent;
    background-color: ${props => props.theme.subBackground};
    border-radius: 200px;
  }
`;

const ColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;
`;

const Column = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: default;
    }
  }
`;

const Info = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  margin-top: 16px;
  padding-bottom: 16px;
  
  border-bottom: 1px solid ${props => props.theme.background};

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  transition: all 0.3s ease-in-out;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      color: ${props => props.theme.primary};
    }
  }
`;

const Tr = styled.tr`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;
`;

const Td = styled.tr`
  
`;

const DdayBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 45px;
  height: 20px;

  border-radius: 30px;
  background-color: ${props => props.theme.primary};
`;

const ProfileBox = styled.img`
  width: 42px;
  height: 42px;

  border-radius: 6px;

  overflow: hidden;

  object-fit: cover;
  object-position: center;
`;

const KakaoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 45px;
  height: 20px;

  border-radius: 30px;
  background-color: #FFB800;
`;

const Text = styled.p`
  font-family: ${props => props.fontFmaily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }
`;